module.exports = __webpack_public_path__ + "img/info.15e87b5c.svg";